import React, { useState, useEffect } from 'react';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import ParticleBackground from './components/ParticleBackground';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ArchitectureSection from './components/ArchitectureSection';
import PredictiveSection from './components/PredictiveSection';
import EcosystemSection from './components/EcosystemSection';
import Footer from './components/Footer';
import ContactModal from './components/ContactModal';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading for smooth entrance
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="w-12 h-12 border-2 border-[#00F0FF] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <LanguageProvider>
      <div 
        className="min-h-screen relative"
        style={{ backgroundColor: '#000000' }}
        data-testid="app-container"
      >
        {/* 3D Particle Background */}
        <ParticleBackground />

        {/* Content Layer */}
        <div className="relative z-10">
          {/* Navigation */}
          <Navbar onOpenModal={openModal} />

          {/* Main Content */}
          <main>
            <HeroSection onOpenModal={openModal} />
            <ArchitectureSection />
            <PredictiveSection />
            <EcosystemSection />
          </main>

          {/* Footer */}
          <Footer />
        </div>

        {/* Contact Modal */}
        <ContactModal isOpen={isModalOpen} onClose={closeModal} />
      </div>
    </LanguageProvider>
  );
}

export default App;
